import React from 'react'
import { Field } from 'redux-form'
import renderTextarea from '../fields/renderTextarea'
import i18n from '../../translations/i18n';

let CoachingOptions = props => {
	let lng = props.lng;
	return (
		<div>
			<div className="row form-section">
				<div className="col-12 form-input">
					<Field
						name="specialInstructions"
						component={renderTextarea}
						label={i18n.t('coaching.special_instructions', {lng})}
						placeholder={i18n.t('coaching.special_instructions_placeholder', {lng})}
					/>
				</div>
			</div>
		</div>
	)
  }


  export default CoachingOptions


// WEBPACK FOOTER //
// ./src/components/coaching/coaching_options.js